import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../../../domain/controllers/ControllerContext';
import {DestinationPicker} from '../DestinationPicker/DestinationPicker';
import {TotalGroup} from '../TotalGroup/TotalGroup';
import {TotalUpdateSkeleton} from '../TotalUpdateSkeleton';

export enum EstimatedTaxDataHook {
  Root = 'EstimatedTax.Root',
  Picker = 'EstimatedTax.Picker',
}

export const EstimatedTax = () => {
  const {
    cartStore: {
      isSummaryUpdating,
      cartSummary: {
        taxSummary: {taxes},
      },
    },
  } = useControllerProps();

  const {t} = useTranslation();

  return (
    <TotalGroup
      dataHook={EstimatedTaxDataHook.Root}
      totals={taxes.map(({name, amount}, index) => ({
        title: name || t('cart.estimated_tax'),
        value: isSummaryUpdating ? () => <TotalUpdateSkeleton /> : amount.formattedConvertedAmount,
        key: index.toString(),
        additionalAttributes: {'data-wix-estimated-tax-price': 'EstimatedTax.EstimatedTaxEstimatedTaxPrice'},
      }))}
      title={t('cart.shipping_destination.tax.choose_region')}
      suffix={<EstimatedTaxSuffix />}
    />
  );
};

export const EstimatedTaxSuffix = () => {
  const {
    orderStore: {shouldDisplayDelivery},
  } = useControllerProps();

  if (shouldDisplayDelivery) {
    return null;
  }
  return <DestinationPicker dataHook={EstimatedTaxDataHook.Picker} />;
};
